import apiClient from '../apiClient';
import { BaseAPI } from '../manager/base';
import { BaseResponse } from '../../types/base.dto';
import { LogisticsTrack } from '../../types/entity/logistics';

/**
 * 物流API服务类
 */
export class LogisticsAPI extends BaseAPI<LogisticsTrack> {
  constructor() {
    super('/logistics');
  }

  /**
   * 获取物流详情
   * @param logisticsNo 物流单号
   */
  async getDetail(logisticsNo: string): Promise<LogisticsTrack> {
    const response = await apiClient.get<BaseResponse<LogisticsTrack>>(`${this.endpoint}/${logisticsNo}`);
    return response.data.data;
  }
}

export const logisticsApi = new LogisticsAPI();

export default logisticsApi;
